import $ from "jquery";

$(function() {
  $(".accordion-steps-images .accordion-button").on( "click", function() {
    let target = $(this).attr('data-bs-target').replace('#', '');
    $('.accordion-image').removeClass('active');
    $('#img-'+target).addClass('active');
  });
});
